import { connect } from 'react-redux';
import { flow, property } from 'lodash';

import { setBank, setAccountStatus } from '../redux/accountsAbroadListFilters/actions';
import AccountsAbroadListFilters from '../components/AccountsAbroadListFilters';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

const accountsAbroadListFiltersSelector = property('profile.accountsAbroadListFilters');

export default connect(
  createStructuredSelector({
    bank: flow(accountsAbroadListFiltersSelector, (accountsAbroadListFilters) =>
      accountsAbroadListFilters.get('bank'),
    ),
    accountStatus: flow(accountsAbroadListFiltersSelector, (accountsAbroadListFilters) =>
      accountsAbroadListFilters.get('accountStatus'),
    ),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        setBank,
        setAccountStatus,
      },
      dispatch,
    ),
)(AccountsAbroadListFilters);
